export default {
  // Header Section
  "discover_your": "உங்கள்",
  "personalized_report_2025": "2025 தனிப்பட்ட அறிக்கை",
  "comprehensive_life_blueprint": "முழுமையான வாழ்க்கை வரைபடம்",
  "personalized_report_2025_description": "2025-க்கான உங்கள் முழுமையான தனிப்பட்ட ஜோதிடப் பகுப்பாய்வைப் பெறுங்கள். தொழில், காதல், நிதி, ஆரோக்கியம், குடும்பம், ஆன்மீக வளர்ச்சி உள்ளிட்ட அனைத்து வாழ்க்கை தளங்களிலும் மாதாந்திர வழிகாட்டுதலுடன் கூடிய விரிவான நுண்ணறிவுகள் மற்றும் தனிப்பயன் பரிகாரங்கள் வழங்கப்படும்.",

  // Service Information
  "enter_details_for_personalized_analysis": "2025 தனிப்பட்ட பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_personalized_analysis_2025": "2025 முழுமையான தனிப்பட்ட பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_personalized_analysis_note": "2025 முன்கணிப்புகளும் தனிப்பயன் வழிகாட்டுதல்களும் அடங்கிய முழு வாழ்க்கை பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_personalized_analysis": "உங்கள் பெயர், தனிப்பட்ட ஜோதிடப் பகுப்பாய்விற்கான தனித்துவ அதிர்வுகளை உருவாக்குகிறது",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_comprehensive_analysis": "முழுமையான ஜோதிட ஜாதகமும் 2025 முன்கணிப்புகளும் கணக்கிட இவை அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_comprehensive_analysis": "வீட்டு நிலைகள் துல்லியமாக கணக்கிடவும் விரிவான பகுப்பாய்வு செய்யவும் சரியான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_personalized_analysis": "இடம், தனிப்பயன் முன்கணிப்புகளுக்கான கிரக நிலைகளில் தாக்கம் செலுத்துகிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் தனிப்பட்ட அறிக்கை தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core 2025 Features
  "comprehensive_life_analysis": "முழுமையான வாழ்க்கை பகுப்பாய்வு",
  "year_2025_predictions": "2025 ஆண்டு முன்கணிப்புகள்",
  "all_life_areas_analysis": "அனைத்து வாழ்க்கை தளங்களின் பகுப்பாய்வு",
  "personalized_remedies_solutions": "தனிப்பயன் பரிகாரங்கள் & தீர்வுகள்",
  "monthly_guidance_2025": "2025 மாதாந்திர வழிகாட்டுதல்",
  "premium_pdf_report": "பிரீமியம் PDF அறிக்கை",

  "what_you_get": "2025 தனிப்பட்ட அறிக்கையில் கிடைப்பவை",
  "complete_life_blueprint": "முழு வாழ்க்கை வரைபடம்",
  "year_2025_forecast": "2025 ஆண்டு முன்னறிவிப்பு",
  "personalized_remedies": "தனிப்பயன் பரிகாரங்கள்",
  "monthly_predictions_guide": "மாதாந்திர முன்கணிப்பு வழிகாட்டி",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் 2025 தனிப்பட்ட அறிக்கையைப் பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "personalized_analysis_processing": "2025-க்கான உங்கள் முழுமையான தனிப்பட்ட அறிக்கையை எங்கள் ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். மாதாந்திர வழிகாட்டுதலுடன் அனைத்து வாழ்க்கை தளங்களிலும் விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_48_hours_delivery_note": "உங்கள் முழுமையான தனிப்பட்ட அறிக்கை 48 மணிநேரத்தில் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் 2025 தனிப்பட்ட அறிக்கை தொகுப்பு",
  "comprehensive_personalized_report": "முழுமையான தனிப்பட்ட அறிக்கை (PDF)",
  "complete_2025_predictions": "2025 முழு முன்கணிப்புகள்",
  "all_life_areas_detailed_analysis": "அனைத்து வாழ்க்கை தளங்களின் விரிவான பகுப்பாய்வு",
  "personalized_remedies_guide": "தனிப்பயன் பரிகார வழிகாட்டி",
  "monthly_action_plan_2025": "2025 மாதாந்திர செயல் திட்டம்",

  // Visual Content
  "sample_personalized_analysis_2025": "2025 மாதிரி தனிப்பட்ட பகுப்பாய்வு",
  "year_2025_focus": "2025 முக்கிய கவனம்",
  "sample_2025_reading": "தொழில் வளர்ச்சி, உறவு நிலைத்தன்மை மற்றும் நிதி விரிவு",
  "sample_2025_preview": "முழுமையான நுண்ணறிவுகளுடன் உங்கள் 2025 தனிப்பயன் பகுப்பாய்வின் முன்னோட்டம்",
  "year_2025_analysis_areas": "2025 பகுப்பாய்வு தளங்கள்",

  // 2025 Life Area Types
  "career_2025": "தொழில் 2025",
  "love_2025": "காதல் 2025",
  "finance_2025": "நிதி 2025",
  "health_2025": "ஆரோக்கியம் 2025",
  "family_2025": "குடும்பம் 2025",
  "spiritual_2025": "ஆன்மீகம் 2025",

  // Status & Processing
  "your_personalized_analysis_status": "உங்கள் தனிப்பட்ட பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் 2025 தனிப்பட்ட அறிக்கை உருவாக்கப்படுகிறது",
  "analysis_processing_message": "எங்கள் ஜோதிட நிபுணர்கள் அனைத்து வாழ்க்கை தளங்களையும் உள்ளடக்கிய உங்கள் முழுமையான 2025 அறிக்கையை விரிவான முன்கணிப்புகளுடன், மாதாந்திர வழிகாட்டுதலுடன் தயாரித்து வருகின்றனர்.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_48_hours": "அறிக்கை 48 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "பிரீமியம் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // 2025 Year Overview
  "year_2025_overview": "2025 ஆண்டு மேலோட்டம்",
  "major_planetary_transits_2025": "2025 முக்கிய கிரக கோச்சாரங்கள்",
  "key_astrological_events_2025": "2025 முக்கிய ஜோதிட நிகழ்வுகள்",
  "annual_theme_2025": "2025 ஆண்டின் தலைப்பு",
  "yearly_opportunities": "ஆண்டிற்க்கான வாய்ப்புகள்",
  "yearly_challenges": "ஆண்டிற்க்கான சவால்கள்",

  // Monthly Analysis 2025
  "january_2025": "ஜனவரி 2025",
  "february_2025": "பிப்ரவரி 2025",
  "march_2025": "மார்ச் 2025",
  "april_2025": "ஏப்ரல் 2025",
  "may_2025": "மே 2025",
  "june_2025": "ஜூன் 2025",
  "july_2025": "ஜூலை 2025",
  "august_2025": "ஆகஸ்ட் 2025",
  "september_2025": "செப்டம்பர் 2025",
  "october_2025": "அக்டோபர் 2025",
  "november_2025": "நவம்பர் 2025",
  "december_2025": "டிசம்பர் 2025",

  // Career 2025
  "career_forecast_2025": "தொழில் முன்னறிவிப்பு 2025",
  "professional_growth_2025": "தொழில்முறை வளர்ச்சி வாய்ப்புகள்",
  "job_changes_2025": "வேலை மாற்றங்கள் & இடமாற்றங்கள்",
  "business_prospects_2025": "வணிக வாய்ப்புகள் 2025",
  "leadership_opportunities_2025": "தலைமை வாய்ப்புகள்",
  "salary_increment_timing": "சம்பள உயர்வு நேரம்",
  "career_challenges_2025": "நடத்த வேண்டிய தொழில் சவால்கள்",

  // Finance 2025
  "financial_forecast_2025": "நிதி முன்னறிவிப்பு 2025",
  "income_growth_2025": "வருமான வளர்ச்சி திறன்",
  "investment_opportunities": "முதலீட்டு வாய்ப்புகள்",
  "expenditure_patterns": "செலவு முறைபாடுகள்",
  "wealth_accumulation": "செல்வச் சேர்க்கை காலவரிசை",
  "financial_challenges": "நிதி சவால்கள்",
  "money_management_tips": "பணம் மேலாண்மை குறிப்புகள்",

  // Love & Relationships 2025
  "love_forecast_2025": "காதல் முன்னறிவிப்பு 2025",
  "relationship_developments": "உறவு முன்னேற்றங்கள்",
  "marriage_prospects_2025": "திருமண வாய்ப்புகள் 2025",
  "family_harmony": "குடும்ப ஒற்றுமை முன்னறிவிப்பு",
  "romantic_opportunities": "காதல் வாய்ப்புகள்",
  "relationship_challenges": "உறவு சவால்கள்",
  "love_life_enhancement": "காதல் வாழ்க்கை மேம்பாடு",

  // Health 2025
  "health_forecast_2025": "ஆரோக்கிய முன்னறிவிப்பு 2025",
  "vitality_levels": "2025 முழுவதும் உயிர்ச்சக்தி நிலைகள்",
  "health_vulnerable_periods": "ஆரோக்கியம் பாதிக்கக் கூடிய காலங்கள்",
  "wellness_recommendations": "நலன் பரிந்துரைகள்",
  "fitness_goals_2025": "உடற்பயிற்சி இலக்குகள் 2025",
  "mental_health_focus": "மனநலம் கவனம் செலுத்த வேண்டிய தளங்கள்",
  "preventive_care_guidance": "முன்னெச்சரிக்கை பராமரிப்பு வழிகாட்டுதல்",

  // Spiritual Growth 2025
  "spiritual_journey_2025": "ஆன்மீகப் பயணம் 2025",
  "meditation_practices": "பரிந்துரைக்கப்படும் தியான முறைகள்",
  "spiritual_awakening": "ஆன்மீக விழிப்பு வாய்ப்புகள்",
  "inner_growth_phases": "உள் வளர்ச்சி கட்டங்கள்",
  "divine_connections": "தெய்வீக இணைப்புகள்",
  "karmic_lessons_2025": "கர்ம பாடங்கள் 2025",

  // Personalized Remedies
  "customized_remedies": "2025-க்கான தனிப்பயன் பரிகாரங்கள்",
  "gemstone_recommendations": "ரத்தின பரிந்துரைகள்",
  "mantra_suggestions": "மந்திர பரிந்துரைகள்",
  "ritual_guidance": "அனுஷ்டான வழிகாட்டுதல்",
  "charitable_activities": "பயனுள்ள தான தர்ம செயற்பாடுகள்",
  "lifestyle_modifications": "வாழ்க்கைமுறை மாற்றங்கள்",
  "lucky_colors_2025": "2025 அதிர்ஷ்ட நிறங்கள்",
  "auspicious_dates": "சுப நாட்கள் & நேரங்கள்",

  // Timing & Cycles
  "auspicious_periods_2025": "சுப காலங்கள் 2025",
  "challenging_periods": "நடத்த வேண்டிய சவாலான காலங்கள்",
  "optimal_decision_timing": "முக்கிய முடிவுகளுக்கான சிறந்த நேரங்கள்",
  "new_venture_timing": "புதிய முயற்சி தொடங்குவதற்கான நேரம்",
  "travel_recommendations": "பயண பரிந்துரைகள்",
  "important_date_alerts": "முக்கிய தேதிகள் அறிவிப்புகள்",

  // Personal Development 2025
  "skill_development_2025": "திறன் மேம்பாட்டிற்கான கவனம் 2025",
  "learning_opportunities": "கற்றல் வாய்ப்புகள்",
  "personal_growth_areas": "தன்வளர்ச்சி தளங்கள்",
  "character_development": "குணநிலை வளர்ச்சி கவனம்",
  "habit_formation": "பயனுள்ள பழக்கங்கள் உருவாக்குதல்",
  "goal_achievement_strategy": "இலக்கு அடைவு தந்திரம்",

  // Social & Networking 2025
  "social_connections_2025": "சமூக இணைப்புகள் 2025",
  "networking_opportunities": "நெட்வொர்க்கிங் வாய்ப்புகள்",
  "friendship_developments": "நட்பு முன்னேற்றங்கள்",
  "community_involvement": "சமூக பங்களிப்பு",
  "social_influence_growth": "சமூக செல்வாக்கு வளர்ச்சி",

  // Technology & Innovation 2025
  "technology_adoption": "தொழில்நுட்ப தழுவல் வழிகாட்டுதல்",
  "digital_opportunities": "டிஜிட்டல் வாய்ப்புகள்",
  "innovation_potential": "புதுமை திறன்",
  "online_presence": "ஆன்லைன் முன்னிலை மேம்பாடு",
  "digital_financial_growth": "டிஜிட்டல் நிதி வளர்ச்சி",

  // Travel & Relocation 2025
  "travel_forecast_2025": "பயணம் முன்னறிவிப்பு 2025",
  "relocation_possibilities": "இடமாற்ற வாய்ப்புகள்",
  "foreign_opportunities": "வெளிநாட்டு வாய்ப்புகள்",
  "pilgrimage_recommendations": "புனித பயண பரிந்துரைகள்",
  "educational_travel": "கல்வி பயணங்கள்",

  // Legal & Official Matters 2025
  "legal_matters_guidance": "சட்ட விவகாரம் வழிகாட்டுதல்",
  "official_work_timing": "அதிகாரப்பூர்வ பணிகள் — உகந்த நேரம்",
  "documentation_periods": "ஆவணப் பணிகளுக்கான சாதக காலங்கள்",
  "government_dealings": "அரசு தொடர்பான செயல்கள்",
  "property_matters": "சொத்து தொடர்பான விவகாரங்கள்",

  // Creative & Artistic 2025
  "creative_expression_2025": "படைப்பு வெளிப்பாடு 2025",
  "artistic_pursuits": "கலைத் தேடல்கள்",
  "creative_projects": "படைப்பு திட்டங்கள் — நேர நிர்ணயம்",
  "artistic_collaborations": "கலை கூட்டாண்மைகள்",
  "creative_income_potential": "படைப்பு வருமான திறன்",

  // Education & Knowledge 2025
  "educational_pursuits": "கல்விசார் முயற்சிகள் 2025",
  "skill_certifications": "திறன் சான்றிதழ்கள்",
  "knowledge_expansion": "அறிவு விரிவு தளங்கள்",
  "research_projects": "ஆராய்ச்சி திட்டங்கள்",
  "teaching_opportunities": "கற்பித்தல் வாய்ப்புகள்",

  // Environmental & Lifestyle 2025
  "living_environment": "வாழ்க்கைச் சூழல் மாற்றங்கள்",
  "lifestyle_upgrades": "வாழ்க்கைமுறை மேம்பாடுகள்",
  "home_improvements": "வீட்டு மேம்பாடுகள் — நேர நிர்ணயம்",
  "environmental_consciousness": "சுற்றுச்சூழல் விழிப்புணர்வு",
  "sustainable_living": "நிலைத்த வாழ்வு முறைகள்"
};
